import { Company, Pagination, User, UserProcess } from '@interfaces';

export const defaultPagination = {
  all: 0,
  limit: 25,
  offset: 0,
  orderBy: 'name',
  orderDir: 'desc',
  count: 0,
};

export const employeesProcessesDefaultPagination = {
  all: 0,
  limit: 25,
  offset: 0,
  orderBy: 'updatedAt',
  orderDir: 'desc',
  count: 0,
};

export const managersDefaultPagination = {
  all: 0,
  limit: 25,
  offset: 0,
  orderBy: 'name',
  orderDir: 'desc',
  count: 0,
};

export type CompanyState = Readonly<{
  loading: boolean;
  companies: Company[];
  pagination: Pagination;
  loadedCompany: Company | null;
  errorMessage: any;
  employeesProcesses: Partial<UserProcess>[];
  employeesProcessesPagination: Pagination;

  loadingManagersList: boolean;
  managers: Partial<User>[];
  managersPagination: Pagination;
  managersErrorMessage: string | null;
  loadedManagerDetails: Partial<User>;
  loadingManagerDetails: boolean;

  loadingCompanyOfSelfRegistered: boolean;
  companyOfSelfRegistered: Partial<Company> | null;

  // Basic data: id, name
  // No pagination.
  // Only isActive = true.
  allActiveCompanies: Partial<Company>[] | null;
}>;

export const initialState: CompanyState = {
  loading: false,
  companies: [],
  pagination: { ...(defaultPagination as Pagination) },
  loadedCompany: null,
  errorMessage: null,

  employeesProcesses: null,
  employeesProcessesPagination: { ...(employeesProcessesDefaultPagination as Pagination) },

  loadingManagersList: false,
  managers: [],
  managersPagination: { ...(managersDefaultPagination as Pagination) },
  managersErrorMessage: null,
  loadedManagerDetails: null,
  loadingManagerDetails: false,

  loadingCompanyOfSelfRegistered: false,
  companyOfSelfRegistered: null,
  allActiveCompanies: null,
};
